import { useQuery } from '@tanstack/react-query';

import { PedidoProps } from '../types';

import { useClientContext } from 'context/ClientContext';
import { useListagemContext } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { RequestListagem, useRequestListagem } from 'hooks/useRequestListagem';
import { useCarrinhoContext } from 'pages/compra/carrinho/contexts';

export function useQueryCarrinho() {
    const { isFinishAllPolling } = useCarrinhoContext();
    const { limit, page, sort, filter, autoLoad } = useListagemContext();
    const requestListagem = useRequestListagem();
    const { hasPermission } = usePermissionsContext();
    const { getFilterValues } = useListagemContext();
    const { idLoja: lojas = [] } = getFilterValues();
    const hasPermissionFinalizacaoGeral = hasPermission(['COMPRA_PEDIDO_FINALIZACAO_GERAL']);
    const { tipoPedido } = useClientContext();
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';
    const isLojasEqualOne = lojas.length === 1;

    return useQuery<RequestListagem<PedidoProps[]>>({
        queryKey: ['carrinho', filter, limit, page, sort],
        queryFn: () =>
            requestListagem({
                url: '/compra/pedidowrapper/rascunho/loja',
                sort: sort.length ? sort : [{ property: 'idPedido', direction: 'DESC' }],
                filter: [
                    { property: 'fgAtivo', operator: 'eq', value: true, logicalOperator: 'AND' },
                    { property: 'vlTotal', operator: 'neq', value: 0 },
                    ...filter,
                ],
                limit: isLojasEqualOne || isTipoPedidoFuncionario ? 100 : limit,
                page,
            }).then((res) => res.data),
        enabled: (isTipoPedidoFuncionario && !hasPermissionFinalizacaoGeral) || autoLoad,
        cacheTime: 0,
        refetchInterval: isFinishAllPolling ? 1500 : false,
    });
}
